import { render, staticRenderFns } from "./DlgConfirmToAddOPDToFav.vue?vue&type=template&id=f30149a8&scoped=true"
import script from "./DlgConfirmToAddOPDToFav.vue?vue&type=script&lang=js"
export * from "./DlgConfirmToAddOPDToFav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30149a8",
  null
  
)

export default component.exports